export const theme = {
  //colors
  colorGrey: '#CDD2DA',
  colorBackgroundFrontPage: '#EDE4D7',
  colorBackgroundFrontPageImprint: '#0A121D',
  colorBackgroundBeige2: '#EFEBE3',
  colorRed: '#FF0000',
  colorGreen: '#00FF00',
  colorTrackListBackgroundNormal: '#D1BB9B',
  colorTrackListBackgroundPast: '#CDD2DA',
  colorTrackListBackgroundActive: '#ffffff',
  colorBackgroundDarkblue: '#303E52',
  colorBackgroundLightGreyBlue: '#CDD2DA',
  colorBackgroundTimeBar: '#596575',
  colorBorderGrey: '#A3A6A9',
  //font colors
  colorFont: '#000000',
  colorFontDarkBlue: '#303E52',
  colorFontTrackListItemActive: '#303E52',
  colorFontColorCookieConsent: '#556172', // in design 76% opacity
  //sizes
  minHeight: 400,
  headerHeight: 48,
  contentMaxWidth: 1068,
  playerControlsHeight: 128,
  frontHeaderSmallHeight: 151,

}
